export default __webpack_public_path__ + "static/PwC_fl_130mmh_c-ea82546af3502e1f4684bbceddaf1344.jpg";